import { Injectable } from '@angular/core';

/**
 * Флаг «пересоздать компоненты на текущей same-URL навигации».
 *
 * Story 99.28 (review P1 — blast radius): глобальный `onSameUrlNavigation: 'reload'`
 * нужен, чтобы Router вообще ОБРАБОТАЛ навигацию на тот же URL (иначе default
 * 'ignore' и cabinet/org-switch не перезапросит данные). Но пересоздавать
 * компонент на КАЖДЫЙ повторный клик по активному пункту меню/логотипу опасно
 * (тихая потеря несохранённого состояния формы — canDeactivate-гардов в проекте нет).
 *
 * Поэтому `SameUrlRouteReuseStrategy` пересоздаёт компоненты ТОЛЬКО пока флаг
 * взведён. Взводят его исключительно cabinet/org-switch перед своей навигацией и
 * сбрасывают после её завершения (finally). `pending()` — peek без сайд-эффекта:
 * `shouldReuseRoute` зовётся по разу на КАЖДЫЙ уровень маршрута, поэтому сброс
 * должен быть привязан к завершению навигации, а не к первому вызову стратегии —
 * иначе пересоздался бы только корень, а лист переиспользовался (рефетч сломан).
 */
@Injectable({ providedIn: 'root' })
export class RouteReloadService {
  // Счётчик (а не boolean): при перекрывающихся switch'ах в одном фрейме finally
  // первой навигации не должен гасить флаг для второй (Party P3 — race). request++
  // / clear-- ; pending = count>0. Пока хоть одна перезагрузка «в полёте» — флаг взведён.
  private _pending = 0;

  /** Взвести перед same-URL навигацией, требующей пересоздания. */
  request(): void {
    this._pending += 1;
  }

  /** Peek без сброса — читается на каждом уровне маршрута за одну навигацию. */
  pending(): boolean {
    return this._pending > 0;
  }

  /** Снять после завершения навигации (в finally у инициатора). Не уходит ниже 0. */
  clear(): void {
    this._pending = Math.max(0, this._pending - 1);
  }
}
